<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
 
}
</script>

<style>
body{
  margin: 0;
}
.el-input-group__append{
  background-color: #fff !important;
}
.el-input-group__prepend{
  background-color: #fff !important;
}
.el-radio{
  display: flex !important;
}

.agreement-item .el-checkbox__inner {
  background-color: #fff; /* 自定义背景颜色 */
  border-color: #EBEBEB; /* 自定义边框颜色 */
  border-radius: 4px;
}
.agreement-item .el-checkbox__inner:hover {
  background-color: #fff; /* 自定义背景颜色 */
  border-color: #EBEBEB; /* 自定义边框颜色 */
}
.agreement-item .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #EE71A7; /* 自定义选中状态的背景颜色 */
  border-color: #EE71A7; /* 自定义选中状态的边框颜色 */
  border-radius: 4px;
}
.el-input__inner:focus{
  border-color: #EE71A7 !important;
}
.el-button--primary{
  background-color: #EE71A7 !important;
}
.el-input__inner{
  color: #333 !important;
}
</style>
